import React, { useState, useRef, useEffect } from "react";
import "./chatSelection.css";
// import API_Root from "../../Constants/API_Root";
// import { authFetch } from "../../Authentication/authService";
import { authFetch } from "../../../../Authentication/authService";

const ChatSelection = () => {
  const [messages, setMessages] = useState([
    {
      sender: "bot",
      text: "Hello! Ask me anything about your workspace documents.",
    },
  ]);

  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);

  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({
      behavior: "smooth",
    });
  }, [messages, loading]);

  const sendMessage = async () => {
    if (!query.trim() || loading) return;

    const userMessage = query;

    setMessages((prev) => [
      ...prev,
      {
        sender: "user",
        text: userMessage,
      },
    ]);

    setQuery("");
    setLoading(true);

    try {
      const response = await authFetch(
        `https://api-discloseai.essolutions.ai/api/v1/ai/merchant/query`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: "ildiko@essolutions.ai",
            include_sources: true,
            project: "personal-workspace",
            query: userMessage,
            top_k: 5,
          }),
        }
      );

      const data = await response.json();

      setMessages((prev) => [
        ...prev,
        {
          sender: "bot",
          text:
            data.answer ||
            "Sorry, I couldn't find an answer.",
        },
      ]);
    } catch (err) {
      console.error(err);

      setMessages((prev) => [
        ...prev,
        {
          sender: "bot",
          text: "Something went wrong.",
        },
      ]);
    }

    setLoading(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      sendMessage();
    }
  };

  return (
    <div className="wrkspc-chat-wrapper">

      <div className="wrkspc-chat-header">
        Workspace AI Chat
      </div>

      <div className="wrkspc-chat-body">

        {messages.map((msg, index) => (
          <div
            key={index}
            className={`wrkspc-chat-message ${
              msg.sender === "user"
                ? "wrkspc-chat-user"
                : "wrkspc-chat-bot"
            }`}
          >
            {msg.text}
          </div>
        ))}

        {loading && (
          <div className="wrkspc-chat-message wrkspc-chat-bot">
            <div className="wrkspc-chat-loading">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        )}

        <div ref={chatEndRef}></div>
      </div>

      <div className="wrkspc-chat-footer">
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyPress}
          placeholder="Ask anything..."
          className="wrkspc-chat-input"
        />

        <button
          className="wrkspc-chat-send"
          onClick={sendMessage}
        >
          Send
        </button>
      </div>

    </div>
  );
};

export default ChatSelection;